<template lang="pug">
  .component-client-drivers
    .action-bar
      .title
        h2 Client Drivers

    base-list(:component="component", :dataLoader="dataLoader")
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from "src/lib/kepler/backoffice"
  import BaseList from "../../../pages/backoffice/BaseList"

  export default {
    name: "ClientDrivers",
    components: {
      BaseList,
    },
    data() {
      return {
        component: require('components/backoffice/Driver')
      }
    },
    created() {
    },
    methods: {
      dataLoader(callback, page, resultsPerPage) {
        KeplerBackofficeSdk.clients.list(page, resultsPerPage, {id: this.$route.params.id}).drivers((data) => {
          callback(data)
        })
      },
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// ClientDrivers.vue?617762cd